/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_AustrittsdatumInputs */

const de__field_austrittsdatum = /** @type {(inputs: _Field_AustrittsdatumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Austrittsdatum`)
};

/**

* @param {_Field_AustrittsdatumInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_austrittsdatum = /** @type {((inputs?: _Field_AustrittsdatumInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_AustrittsdatumInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_austrittsdatum(inputs)
});